import { Injectable } from "@angular/core";
import { MathEnum } from "@infrastructure/math-state-enum";
import { PriceSettingEnum } from "@infrastructure/price-setting.enum";
import { BagErrorModel } from "@models/api-models/bag-error-model";
import { BagDisplayModel } from "@models/bag-display-model";
import { OrderIdsModel } from "@models/orderIds-model";
import { PriceSettingModel } from "@models/price-setting.model";
import { GuidService } from "@services/guid.service";
import { BehaviorSubject, Subject } from "rxjs";

export enum AppModeEnum {
	default = 0,
	repair = 1,
	substitution = 2
}

@Injectable({
	providedIn: 'root'
})
export class AppState {

	public showChineseLicenseId = false;
	public showLinkToStoragePage = false;
	public appWasUpdated = false;
	public priceModuleEnabled = new BehaviorSubject<boolean | undefined>(false);
	public showPreciousTheme = new BehaviorSubject<boolean>(true);
	public priceSetting: BehaviorSubject<PriceSettingModel>;
	public priceWasPossiblyInfluenced: Subject<any> = new Subject();
	public appMode = new BehaviorSubject<AppModeEnum>(AppModeEnum.default);
	public afterSalesCRMCaseNo = new BehaviorSubject<string | undefined>(undefined);
	public afterSalesSAPClaimNo = new BehaviorSubject<string | null>(null);
	public afterSalesSerialNo = new BehaviorSubject<string | null>(null);
	public bagDisplay = new BehaviorSubject<BagDisplayModel>(new BagDisplayModel(0, 0));
	public orderIds: Array<OrderIdsModel> = [];
	public bagErrors = new BehaviorSubject<Array<BagErrorModel>>([]);
	private activeAddToBagExecutions = new BehaviorSubject<number>(0);
	public hasActiveAddToBagExecutionsStatus = new BehaviorSubject<boolean>(false);

	constructor(
		private guidService: GuidService
	) {
		this.priceSetting = new BehaviorSubject<PriceSettingModel>(new PriceSettingModel(PriceSettingEnum.AllowNone, ''));

		this.activeAddToBagExecutions.subscribe((value) => {
			const currentHasActiveAddToBagExecutionsStatus = this.hasActiveAddToBagExecutionsStatus.getValue();
			if (value === 0 && currentHasActiveAddToBagExecutionsStatus === true) {
				this.hasActiveAddToBagExecutionsStatus.next(false);
			}
			else if (value > 0 && currentHasActiveAddToBagExecutionsStatus === false) {
				this.hasActiveAddToBagExecutionsStatus.next(true);
			}
		});
	}

	public appModeIsAfterSales() {
		const state = this.appMode.value === AppModeEnum.repair || this.appMode.value === AppModeEnum.substitution;
		return state;
	}

	public ResetActiveAddToBagExecutionsCount() {
		var bagDisplay = this.bagDisplay.getValue();
		this.activeAddToBagExecutions.next(0);
		this.hasActiveAddToBagExecutionsStatus.next(false);
		this.bagDisplay.next(bagDisplay);
	}

	public concurrentAddToBagExecutions(updateType: MathEnum) {
		var currentActiveAddToBagExecutions = this.activeAddToBagExecutions.getValue();
		updateType == MathEnum.Addition ? currentActiveAddToBagExecutions++ : currentActiveAddToBagExecutions--;
		this.activeAddToBagExecutions.next(currentActiveAddToBagExecutions);
	}

	public async setOrderIds(orderIds: OrderIdsModel[]) {
		this.orderIds = orderIds;
	}

	public addBagError(title: string) {
		const newError: BagErrorModel = {
			Id: this.guidService.generateGUID().toString(),
			Title: title
		};
		const currentErrors = this.bagErrors.getValue();
		currentErrors.push(newError);
		this.bagErrors.next(currentErrors);
	}

	public removeBagErrorById(id: string) {
		const currentErrors = this.bagErrors.getValue();
		const updatedErrors = currentErrors.filter(error => error.Id !== id);
		this.bagErrors.next(updatedErrors);
	}
}
